import React, { useState } from 'react'
import Modal from 'presentation/shared/components/Modal'
import ConfirmationModal from 'presentation/shared/components/Modal'
import SuccessModal from 'presentation/shared/components/Modal'
import { translateRegistrationStepName } from 'domain/entities/overall-registration-status-model'
import { Label } from 'presentation/shared/components/TextField/styles'
import { Container } from 'presentation/shared/components/Container'
import Button from 'presentation/shared/components/Button'
import SupportText from 'presentation/shared/components/SupportText'
import { toast } from 'react-toastify'
import DoctorConfirmation from 'presentation/assets/icons/doctor-confirmation.png'
import SuccessRegisterPendency from 'presentation/assets/icons/success-register-pendency.png'

import * as S from './styles'
import { useHistory } from 'react-router'
import { newRegistrationDetailsContext } from 'presentation/hospital/layouts/DoctorRegister/NewRegistrationsDetails/context'
import { useServices } from 'presentation/hooks/use-services'

type Props = {
  onClose(): void
  show: boolean
  doctor_register_id: number
}

const CreateRegisterPendencyModal = ({
  show,
  onClose,
  doctor_register_id
}: Props) => {
  const history = useHistory()
  const { doctorRegister } = useServices()

  const [confirmationModal, setConfirmationModal] = useState(false)
  const [successModal, setSuccessModal] = useState(false)

  const createRegisterPendency = async () => {
    try {
      await doctorRegister.createDoctorRegisterPendency({ doctor_register_id })
      setSuccessModal(true)
    } catch (error) {
      toast.error('Erro ao criar pendências')
    }
  }

  return (
    <>
      <Modal
        data-testid="modal-generate-pendency"
        title="Deseja enviar alterações para análise?"
        show={show}
        preventAutomateClose
        style={{ width: '40%', height: '80%' }}
      >
        <Container
          data-testid="container-generate-pendency"
          title="Gerar Pendência"
          noPadding
          subtitle="Os seguintes dados estão pendentes e precisam ser resolvidos para dar segmento ao processo de cadastro:"
          style={{
            placeSelf: 'flex-start',
            textAlign: 'left',
            alignItems: 'center'
          }}
        >
          <div
            style={{
              padding: '25px'
            }}
          >
            {newRegistrationDetailsContext.pendencies?.map((x) => {
              return (
                <div key={x.doctor_register_step_id}>
                  <Label labelColor="gray">
                    {x.name && translateRegistrationStepName(x.name)}
                  </Label>
                  <SupportText
                    style={{
                      marginTop: '15px',
                      marginLeft: '20px',
                      marginBottom: '15px'
                    }}
                    color="lightGray"
                  >
                    • {x.getActivePendency?.text}
                  </SupportText>
                </div>
              )
            })}
          </div>
        </Container>

        <S.Buttons>
          <Button
            data-testid="btn-cancel-generate-pendency"
            variant="outlined"
            type="button"
            onClick={() => onClose()}
          >
            Cancelar
          </Button>
          <Button
            data-testid="btn-send-generate-pendency"
            type="button"
            onClick={() => {
              onClose()
              setConfirmationModal(true)
            }}
          >
            Enviar
          </Button>
        </S.Buttons>
      </Modal>
      <ConfirmationModal
        data-testid="modal-confirm-generate-pendency"
        show={confirmationModal}
        style={{ width: '554px', height: '40%' }}
        preventAutomateClose
      >
        <img style={{ height: '165px' }} src={DoctorConfirmation} />
        <S.Title>Deseja gerar nova pendencia?</S.Title>
        <S.Buttons>
          <Button
            data-testid="btn-cancel-confirm-generate-pendency"
            variant="outlined"
            type="button"
            onClick={() => setConfirmationModal(false)}
          >
            Cancelar
          </Button>
          <Button
            data-testid="btn-confirm-generate-pendency"
            type="button"
            onClick={() => {
              setConfirmationModal(false)
              createRegisterPendency()
            }}
          >
            Prosseguir
          </Button>
        </S.Buttons>
      </ConfirmationModal>
      <SuccessModal
        data-testid="modal-success-generate-pendency"
        show={successModal}
        style={{ width: '554px', height: '40%' }}
        preventAutomateClose
      >
        <img style={{ height: '165px' }} src={SuccessRegisterPendency} />
        <S.Title>Pendência gerada com sucesso</S.Title>

        <Button
          data-testid="btn-success-generate-pendency"
          style={{ marginTop: '2rem' }}
          type="button"
          onClick={() => history.goBack()}
        >
          Voltar a novos cadastros
        </Button>
      </SuccessModal>
    </>
  )
}

export default CreateRegisterPendencyModal
